import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";
import { misc } from "app/themes/colors";

type StatusIconPlaceholderProps = {
  color?: string;
  sx?: SxProps;
};
export default function StatusIconPlaceholder({
  color = misc.darkYellow,
  sx,
}: StatusIconPlaceholderProps) {
  return (
    <Box
      width={12}
      minHeight={12}
      minWidth={12}
      bgcolor={color}
      borderRadius="2px"
      sx={sx}
    />
  );
}
